'use client'

import {ProductScreen} from '../product'
import {observer} from 'mobx-react'
import React from 'react'

import {CatalogProductContent} from '@/src/core/domain/entities/catalog'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'

import {ProductProvider} from '@/src/entities/product'

export type CatalogProductPageProps = ServerPageData<CatalogProductContent>

export const CatalogProductScreen = observer((props: CatalogProductPageProps) => {
  const {content} = props

  return (
    <>
      <meta name="product" content="Digi Product Page" />
      <ProductProvider product={content.product}>
        <ProductScreen {...props} content={content} />
      </ProductProvider>
    </>
  )
})
